import React from 'react';
import classnames from 'classnames';

import s from './WidgetBoxWideWrapper.scss';

export type Props = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>;

export const WidgetBoxWideWrapper = React.forwardRef<HTMLDivElement, Props>(
  ({ className, ...props }, ref) => {
    return (
      <div {...props} className={classnames(className, s['root'])} ref={ref} />
    );
  }
);
WidgetBoxWideWrapper.displayName = 'WidgetBoxWideWrapper';

export default WidgetBoxWideWrapper;
